<template>
  <div class="nav-tabs-card">
    <ul class="nav-tabs">
      <li class="nav-item" v-for="tab in tabs" :key="tab.name">
        <a
          class="nav-link"
          :class="{ active: activeTab === tab.name }"
          @click="updateActiveTab(tab)"
        >
          <font-awesome-icon :icon="tab.icon" class="icon" />
          <span class="label">{{ tab.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NavTabs",
  props: {
    activeTab: String,
  },
  data() {
    return {
      tabs: [
        { name: "eventos", label: "Eventos", icon: "fas fa-calendar-alt" },
        { name: "lotes", label: "Lotes", icon: "fa-solid fa-qrcode" },
        { name: "moverPlantasASalas", label: "Gestionar Salas", icon: "fa-solid fa-home" },
        { name: "cultivo", label: "Mi Plan de Cultivo", icon: "fas fa-seedling" },
        { name: "administrarProyecto", label: "Administrar Proyecto", icon: "fas fa-info-circle" },
      ],
    };
  },
  methods: {
    updateActiveTab(tab) {
      this.$emit("update:activeTab", tab.name);
    },
  },
};
</script>

<style scoped>
.nav-tabs-card {
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  max-width: 350px;
  min-height: 50px;
  margin: auto;
}

.nav-tabs {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem; /* espacio reducido entre items */
}

.nav-link {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 500;
  color: var(--app-primary);
  text-decoration: none;
  padding: 0.4rem 0.75rem; /* padding vertical reducido */
  border-radius: 8px;
  transition: background-color 0.3s, font-size 0.3s, padding 0.3s;
}

.nav-link.active {
  background-color: var(--app-primary);
  color: #fff;
  font-size: 1.2rem; /* resalta el activo con fuente mayor */
  padding: 0.5rem 0.75rem; /* ligero ajuste para el activo */
}

.nav-link:hover {
  background-color: #e9ecef;
}

.icon {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

.label {
  flex: 1;
}

@media (max-width: 768px) {
  .nav-tabs {
    flex-direction: row;
    justify-content: space-around;
    padding: 0 0.5rem;
    width: 100%;
  }

  .nav-link {
    padding: 0.2rem;
    flex-grow: 1;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .nav-link .icon {
    font-size: 1.5rem;
  }

  .nav-link .label {
    display: none;
  }
}
</style>
